export function getLanguage() {
  return document.documentElement.lang || "en"
}
